import ReferenceDocumentsPreviewController from './reference-documents-preview.controller';
import { ReferenceDocumentsPreviewProps } from './reference-documents-preview.model';

const ReferenceDocumentsPreview = (props: ReferenceDocumentsPreviewProps) => {
  return <ReferenceDocumentsPreviewController {...props} />;
};

export default ReferenceDocumentsPreview;
